import { Controller } from "@hotwired/stimulus";
import { useIntersection } from "stimulus-use";

export default class extends Controller {
  static targets = ["header", "menu", "sentinel", "menuToggle"];
  static classes = ["headerBackground", "menuOpen"];

  declare readonly headerTarget: HTMLElement;
  declare readonly hasHeaderTarget: boolean;
  declare readonly menuTarget: HTMLElement;
  declare readonly hasMenuTarget: boolean;
  declare readonly sentinelTarget: HTMLElement;
  declare readonly hasSentinelTarget: boolean;
  declare readonly menuToggleTarget: HTMLElement;
  declare readonly hasMenuToggleTarget: boolean;

  declare readonly headerBackgroundClass: string;
  declare readonly headerBackgroundClasses: string[];
  declare readonly hasHeaderBackgroundClass: boolean;
  declare readonly menuOpenClass: string;
  declare readonly menuOpenClasses: string[];
  declare readonly hasMenuOpenClass: boolean;

  open = false;
  overPageBody: boolean | undefined;

  connect() {
    document.addEventListener("turbo:before-cache", this.reset);
    if (this.hasSentinelTarget) {
      useIntersection(this, {
        element: this.sentinelTarget,
      });
      // on scroll restoration, initial intersection doesn't fire (??)
      // so we need to manually measure the position of the sentinel
      this.overPageBody = this.sentinelTarget.getBoundingClientRect().top < 0;
    } else {
      this.overPageBody = true;
    }
    this.update();
  }

  disconnect(): void {
    document.removeEventListener("turbo:before-cache", this.reset);
  }

  reset = () => {
    this.open = false;
    this.overPageBody = undefined;
    this.update();
  };

  toggleMenu = () => {
    this.open = !this.open;
    this.update();
  };

  appear() {
    this.overPageBody = false;
    this.update();
  }

  disappear() {
    this.overPageBody = true;
    this.update();
  }

  update() {
    if (this.hasMenuTarget) {
      if (this.open) {
        this.menuTarget.classList.add(...this.menuOpenClasses);
      } else {
        this.menuTarget.classList.remove(...this.menuOpenClasses);
      }
    }

    if (this.hasHeaderTarget) {
      if (this.open || this.overPageBody) {
        this.headerTarget.classList.add(...this.headerBackgroundClasses);
      } else {
        this.headerTarget.classList.remove(...this.headerBackgroundClasses);
      }
    }
  }
}
